const HeaderLogo = '/assets/andimar/andimar-logo.svg';
const DestinationBanner = '/assets/andimar/destinations/destino_banner.jpg';
const FooterLogo = '/assets/tepual/general/Footer-BusesTepualLogo.svg';
const ContactBg = '/assets/tepual/home/home-background.jpg';
const PopupIcon = '/assets/andimar/Andimar-PopUp.jpg';
const BookingActive = '/assets/tepual/home/BuyTicketIcon-Active.svg';
const BookingInActive = '/assets/tepual/home/BuyTicketIcon-Inactive.svg';
const CancelActive = '/assets/tepual/home/CancelTicketIcon-Active.svg';
const CancelInActive = '/assets/tepual/home/CancelTicketIcon-Inactive.svg';
const OriginIcon = '/assets/andimar/origin.svg';
const ContactIcon = '/assets/andimar/contact-by/contact.svg';
const EmailIcon = '/assets/andimar/contact-by/email.svg';
const TelephoneIcon = '/assets/andimar/contact-by/telephone.svg';
const DestinationIcon = '/assets/andimar/destination.svg';
const CalendarIcon = '/assets/andimar/navbar-dateIcon.svg';
const SearchIcon = '/assets/andimar/navbar-searchIcon.svg';
const BlueArrow = '/assets/andimar/favoriteDestinations/andimar-blue-arrow.svg';
const ClockIcon = '/assets/andimar/favoriteDestinations/andimar-clock.svg';
const FleetBanner = '/assets/andimar/fleet/fleet-banner.jpg';
const FleetTv = '/assets/andimar/fleet/18.svg';
const FleetToilet = '/assets/andimar/fleet/19.svg';
const FleetAc = '/assets/andimar/fleet/20.svg';
const FleetSnacks = '/assets/andimar/fleet/21.svg';
const FleetBed = '/assets/andimar/fleet/22.svg';
const AmenitiesLeftImage = '/assets/andimar/fleet/24.jpg';
const BuyIconWhite = '/assets/andimar/buy-ticket.svg';
const BuyIconBlue = '/assets/andimar/buy-ticket-blue.svg';
const CancelIconWhite = '/assets/andimar/cancel-ticket.svg';
const CancelIconBlue = '/assets/andimar/cancel-ticket-blue.svg';
const TelephoneWhite = '/assets/andimar/contact-by/telephone-white.svg';
const EmailWhite = '/assets/andimar/contact-by/email-white.svg';
const checkboxIcon = '/static/images/icons/AndimarWebsite-Checkbox.png';
const animation = '/static/images/animations/Bus-LoadingAnimation-Andimar.gif';

const pnr = '/assets/andimar/Andimar-Website-Home-WhereToFindMyPNR.svg';
const close = '/assets/viatur/icons/close.svg';

// const userIcon = '/static/images/user_red_dot.svg';

const success = '/assets/bahia/Blue/MyAccount-IllustratedIcons-CheckMark-Blue.svg';
const failure = '/assets/bahia/Blue/MyAccount-IllustratedIcons-Information-Blue.svg';

const tick = '/assets/bahia/Blue/MyAccount-IllustratedIcons-Tick-Blue.svg';
const heartOn = '/assets/bahia/Blue/MyAccount-IllustratedIcons-HeartOn-Blue.svg';
const heartOff = '/assets/bahia/Blue/MyAccount-IllustratedIcons-HeartOff-Blue.svg';
const downArrow = '/assets/bahia/Blue/MyAccount-IllustratedIcons-DropDown-Blue.svg';
const registrationSuccess = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RightDocument-Blue.svg';

const userIcon = '/assets/bahia/Home/user_red_dot-BahiaAzul.svg';
const trips = '/assets/bahia/Blue/MyAccount-IllustratedIcons-MyTrips-Blue.svg';
const cards = '/assets/bahia/Blue/MyAccount-IllustratedIcons-MyCards-Blue.svg';
const wallet = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RechargeWallet-Blue.svg';
const transaction = '/assets/bahia/Blue/MyAccount-IllustratedIcons-ShareMoney-Blue.svg';
const otp = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RestorePassword-Blue.svg';

const paso_1 = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RechargeWallet-Blue.svg';
const paso_2 = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RechargePoints-Blue.svg';
const paso_3 = '/assets/bahia/Blue/MyAccount-IllustratedIcons-ID-Blue.svg';
const paso_4 = '/assets/bahia/Blue/MyAccount-IllustratedIcons-Tickets-Blue.svg';

const operatorPay = '/assets/andimar/Andimarpay.svg'

const andimarIcons = [
  // { icon: userIcon, name: 'userIcon' },

  { icon: downArrow, name: 'downArrow' },
  { icon: userIcon, name: 'userIcon' },
  { icon: trips, name: 'trips' },
  { icon: cards, name: 'cards' },
  { icon: wallet, name: 'wallet' },
  { icon: transaction, name: 'transaction' },
  { icon: success, name: 'success' },
  { icon: failure, name: 'failure' },
  { icon: tick, name: 'tick' },
  { icon: heartOn, name: 'heartOn' },
  { icon: heartOff, name: 'heartOff' },
  { icon: registrationSuccess, name: 'registrationSuccess' },
  { icon: otp, name: 'otp' },

  { icon: paso_1, name: 'paso_1' },
  { icon: paso_2, name: 'paso_2' },
  { icon: paso_3, name: 'paso_3' },
  { icon: paso_4, name: 'paso_4' },

  { icon: HeaderLogo, name: 'headerLogo' },
  { icon: FooterLogo, name: 'footerLogo' },
  { icon: success, name: 'success' },
  { icon: failure, name: 'failure' },
  { icon: ContactBg, name: 'ContactBg' },
  { icon: close, name: 'close' },
  { icon: BookingInActive, name: 'BIA' },
  { icon: BookingActive, name: 'BA' },
  { icon: CancelInActive, name: 'CIA' },
  { icon: CancelActive, name: 'CA' },
  { icon: OriginIcon, name: 'Origin' },
  { icon: DestinationIcon, name: 'Destination' },
  { icon: CalendarIcon, name: 'Calendar' },
  { icon: SearchIcon, name: 'Search' },
  { icon: PopupIcon, name: 'Popup' },
  { icon: DestinationBanner, name: 'DestinationBanner' },
  { icon: ContactIcon, name: 'ContactIcon' },
  { icon: TelephoneIcon, name: 'TelephoneIcon' },
  { icon: TelephoneIcon, name: 'TelephoneIcon' },
  { icon: BlueArrow, name: 'BlueArrow' },
  { icon: ClockIcon, name: 'ClockIcon' },
  { icon: FleetBanner, name: 'FleetBanner' },
  { icon: FleetTv, name: 'FleetTv' },
  { icon: FleetToilet, name: 'FleetToilet' },
  { icon: FleetAc, name: 'FleetAc' },
  { icon: FleetSnacks, name: 'FleetSnacks' },
  { icon: FleetBed, name: 'FleetBed' },
  { icon: AmenitiesLeftImage, name: 'AmenitiesLeftImage' },
  { icon: pnr, name: 'pnr' },
  { icon: EmailIcon, name: 'EmailIcon' },
  { icon: BuyIconWhite, name: 'BuyIconWhite' },
  { icon: BuyIconBlue, name: 'BuyIconBlue' },
  { icon: CancelIconWhite, name: 'CancelIconWhite' },
  { icon: CancelIconBlue, name: 'CancelIconBlue' },
  { icon: TelephoneWhite, name: 'TelephoneWhite' },
  { icon: EmailWhite, name: 'EmailWhite' },
  { icon: checkboxIcon, name: 'Checkbox' },
  { icon: animation, name: 'animation' },
  { icon: operatorPay, name: 'operatorPay' },

];

export default andimarIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/andimarIcons.js